import { css } from '@emotion/react';

export const linkedInEmbedded = css`
  width: 640px;
  height: 360px;
`;
